import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";
import { brand } from "@/mocks/navigation";
import { projectGallery } from "@/mocks/projects";

export default function ProjectsCtaSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="Projects & Applications"
              title="Where Retrofit Applies Across Mobility"
              description="Project and application categories where retrofit is being considered. Specific customer names, vehicle counts and performance results are only published when verified — actual project details are coming soon."
            />
            <div className="shrink-0">
              <ActionButton to="/projects" variant="outline" size="md" iconRight="ri-arrow-right-line">
                View Projects
              </ActionButton>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {projectGallery.map((project, index) => (
            <Reveal key={project.key} delay={index * 0.05}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors duration-300 hover:border-primary-300">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-primary-700">
                    <i className={`${project.icon} text-xl`} />
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-[10px] font-semibold uppercase tracking-[0.12em] text-secondary-900">
                    {project.category}
                  </span>
                </div>
                <h3 className="mt-5 text-base font-semibold text-foreground-950">{project.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {project.description}
                </p>
                <p className="mt-4 font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-foreground-500">
                  {project.status}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-16 w-full max-w-container px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg">
            <div className="absolute inset-0 h-full w-full">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20abstract%20electric%20mobility%20background%20with%20flowing%20green%20energy%20lines%20over%20graphite%20metal%20texture%2C%20premium%20automotive%20technology%20aesthetic%2C%20cinematic%2C%20minimal&width=1920&height=900&seq=klz-cta-01&orientation=landscape"
                alt="Electric mobility energy lines over graphite metal texture"
                title="Transform your vehicle - EV retrofit"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/[0.92] via-foreground-950/80 to-foreground-950/70" />
            <div className="relative z-10 px-6 py-16 md:px-14 md:py-24">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.22em] text-primary-300">
                Final Message
              </p>
              <h2 className="mt-5 max-w-3xl text-2xl font-extrabold leading-tight text-background-50 md:text-5xl">
                Don&apos;t Replace Your Vehicle. Transform It. Electrify It.
              </h2>
              <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                {brand.closing} Start with a technical assessment and find out what is possible for
                the vehicle or fleet you already operate.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <ActionButton to="/ev-retrofit#eligibility" variant="primary" size="lg" icon="ri-flashlight-line">
                  Check Retrofit Eligibility
                </ActionButton>
                <ActionButton to="/contact" variant="outlineLight" size="lg" icon="ri-customer-service-2-line">
                  Talk to Our Team
                </ActionButton>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}